export default "__VITE_ASSET__rQ0iWQQE__"